import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function FormFilterTag() {
    const [filterCodigo, setfilterCodigo] = useState<FilterValuesProps>({
        property: 'idTagComunicado',
        operator: 'eq',
        value: null,
        idProperty: 'idTagComunicado',
    });
    const [nomeTag, setNomeTag] = useState<FilterValuesProps>({
        property: 'dsTagComunicado',
        operator: 'like',
        idProperty: 'dsTagComunicado',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterCodigo, setter: setfilterCodigo },
                { value: nomeTag, setter: setNomeTag },
            ]}
        >
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Código"
                    value={filterCodigo.value}
                    style={{ marginBottom: 20 }}
                    onChange={(e) => setfilterCodigo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Tag"
                    value={nomeTag.value}
                    onChange={(e) => setNomeTag((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
